export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 7_02.72e19384.jpg";